import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RegisterFooter, RegisterHeader, withRouter } from "../../CommonComponents";
import GLOBAL_CONST from "../../../helper/AppConstants";
import { toast, Slide } from "react-toastify";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { hideModal, setEnvironment, setHelpList, setLoginType, showModal } from "../../../common/actions/userAccount";
import { createLoadingSelector } from "../../../common/reducers/selectors";
import { checkEmailIsAllowed } from "../../../common/actions/userAccount/RegistrationAction";
import { getEnvironment } from "../../../common/services/config";

const loadingSelector = createLoadingSelector(["single_sign_on"]);

function SingleSignOn(props) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailInvalid, setEmailInvalid] = useState("");
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);

  const cleanEmail = (rawEmail) => {
    if (!rawEmail) return rawEmail;
    let e = rawEmail.trim();
    e = e.replace(/(\.staging|\.develop)(?=$|@)/gi, "");
    e = e.replace(/\.(staging|develop)\b/gi, "");

    return e;
  };

  const detectEnvFromEmail = (rawEmail) => {
    const lower = (rawEmail || "").toLowerCase();

    if (/\.(staging)\b/i.test(lower)) return "staging";
    if (/\.develop\b/i.test(lower)) return "develop";
    return "prod";
  };


  const validateAndSubmit = () => {
    const currentEmail = email.trim();
    const reg =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!reg.test(currentEmail)) {
      setEmailInvalid(props.t('emailError'));
      return;
    } else {
      setEmailInvalid("");
      setFormSubmitLoading(true);
      checkSAMLLoginAllowed(currentEmail);
    }
  };

  const checkSAMLLoginAllowed = async (rawEmail) => {
    //console.log("checkSAMLLogin called!");
    const detectedEnv = detectEnvFromEmail(rawEmail);
    const cleaned = cleanEmail(rawEmail);

    console.log("detectedEnv:", detectedEnv);
    console.log("raw email:", rawEmail);
    //console.log("cleaned email to check:", cleaned);

    props.doSetEnvironment({
      env: detectedEnv,
      callback: () => callSAMLLoginCheck(cleaned),
    });
  };

  const callSAMLLoginCheck = async (trimmedEmail) => {
    console.log("Calling doCheckEmailisAllowed now");
    props.doCheckEmailisAllowed({
      email: trimmedEmail,
      callback: ({ Success, Data, Message }) => {
        // console.log("SAML login callback executed", Data);
        setFormSubmitLoading(false);
        if (Data) {
          openSAMLLogin(trimmedEmail);
        } else {
          toast.error(
            Message ||
            "This SSO is only for districts using Parent Single Sign-On. Please verify your email used for District login or try a different login option",
            {
              autoClose: 2000,
              transition: Slide,
              hideProgressBar: true,
              icon: false,
            }
          );
        }
      },
    });
  };

  const openSAMLLogin = (trimmedEmail) => {
    try {
      props.doSetLoginType(GLOBAL_CONST.LOGIN_TYPE.SAML_LOGIN);
      const samlLoginUrl = `${getEnvironment()}sso/SamlLogin?email=${encodeURIComponent(trimmedEmail)}&web=true`;
      console.log("SAML Login URL:", samlLoginUrl);
      window.location.assign(samlLoginUrl);
    } catch (e) {
      console.error("Error constructing SAML login URL", e);
      toast.error("Unable to start Single Sign-On.", {
        autoClose: 2000,
        transition: Slide,
        hideProgressBar: true,
        icon: false,
      });
    }
  };

  useEffect(() => {
    props.dosetHelpList({
      stackType: "AuthStack",
      screen: GLOBAL_CONST.SCREEN_NAMES.SINGLE_SIGN_ON,
      title: props.t('loginScreen-sso-text'),
    });
  }, []);

  const openHelpModal = () => {
    props.doShowModal({
      modalScreenName: "HelpListing",
      modalClassName: "helpSupportModal sidebar-modal right",
      params: {
        stackType: props.setHelpListData?.stackType,
        screen: props.setHelpListData?.screen,
        title: props.setHelpListData?.title,
      },
    });
  };

  return (
    <section className="singleSignOn registration">
      <div className="wrapper">
        <div className="landing-wrapper">
          <div className="row h-100vh nomargin-row">
            <RegisterHeader />
            <div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 sidebar-col">
              <div className="sidebar-wrapper">
                <div className="container-sect">
                  <form className="form-style1">
                    <div className="nav-buttons">
                      <h2 className="title-3 signon-title">{props.t('loginScreen-sso-text')}</h2>
                      <button
                        type="button"
                        className="btn btn-action close-btn2"
                        onClick={() => navigate("/")}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>

                    <div className="main mt-40">
                      <div className="title-sect mb-40">
                        <h2 className="title-3">{props.t('ssoAccess_text')}</h2>
                        <p className="helptext">
                          {props.t('sso_text')}
                        </p>
                      </div>

                      <div className="form-group">
                        <input
                          type="email"
                          className={`form-control ${emailInvalid ? "input-error" : ""
                            }`}
                          placeholder={props.t('regAcctScr-emailAddrs')}
                          name="email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setEmailInvalid("");
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              event.preventDefault();
                              validateAndSubmit();
                            }
                          }}
                        />
                        <i className="fa-solid fa-user-circle-o userIcon"></i>
                        <span className="error">{emailInvalid}</span>
                      </div>

                      <div className="form-group">
                        <button
                          type="button"
                          className="btn needhelp-label mt-20 mb-20"
                          onClick={() => {
                            openHelpModal(); 
                          }}
                        >
                          {props.t('regNameScr-needHelp')}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={validateAndSubmit}
                          disabled={formSubmitLoading}
                        >
                          {formSubmitLoading ? (
                            <i className="fas fa-sync-alt fa-spin"></i>
                          ) : (
                            null
                          )}{" "}
                          &nbsp; {props.t("SUBMIT")}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="toast-container-placeholder" />
                <RegisterFooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function mapStateToProps(state) {
  return {
    forgotPasswordSuccess: state.userAccount.forgotPasswordSuccess,
    forgotPasswordResponse: state.userAccount.forgotPasswordResponse,
    isFetching: loadingSelector(state),
    error: state.userAccount.error,
    setHelpListData: state.userAccount.setHelpListData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doSetEnvironment: (data) => dispatch(setEnvironment(data)),
    doCheckEmailisAllowed: (data) => dispatch(checkEmailIsAllowed(data)),
    doSetLoginType: data => dispatch(setLoginType(data)),
    dosetHelpList: (data) => dispatch(setHelpList(data)),
    doShowModal: (data) => dispatch(showModal(data)),
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(SingleSignOn))
);